import React from 'react';
import { CheckCircle2, BookOpen, ArrowRight, Star } from 'lucide-react';

const moreBooks = [
  {
    id: 'unlock-business-millions',
    title: 'Unlock Business Millions',
    author: 'L. Collins',
    format: 'Hardcover · 189 pages',
    cover: 'https://customer-assets.emergentagent.com/job_f39e6fee-79f2-4684-89ed-32979a04e68f/artifacts/xhtt232u_View%20recent%20photos%2020.png',
    link: 'https://www.amazon.com/dp/B0H17WVPXJ',
    description: 'Learn to speak the language of lenders and present your business as a meticulously calculated investment. The blueprint for bridging the gap between your ambitions and serious business funding.'
  },
  {
    id: 'twin-effect',
    title: 'The Twin Effect: How to Clone Your Intelligence with A.I.',
    author: 'L. Collins',
    format: 'Paperback · 123 pages',
    cover: 'https://m.media-amazon.com/images/I/71qo+ZonP7L._SY522_.jpg',
    link: 'https://www.amazon.com/dp/B0GF27134Y',
    description: 'Create an AI-powered digital twin of yourself that speaks, interacts, and sells on your behalf 24/7. The exact step-by-step process used to generate over $53,000 in 30 days — no technical background required.'
  },
  {
    id: 'ssn-power',
    title: 'Unlocking the Power of Your Social Security Number',
    author: 'L. Collins',
    format: 'Paperback · 25 pages',
    cover: 'https://m.media-amazon.com/images/I/71J+mJIw7FL._SY522_.jpg',
    link: 'https://www.amazon.com/dp/B0DT6MW98F',
    description: 'Your SSN is more than an identifier — it\'s a key to financial opportunity. A step-by-step guide to understanding its connection to the Federal Reserve System and leveraging it for financial freedom.'
  },
  {
    id: 'the-gem',
    title: 'The Gem: Unlocking the Power Within',
    author: 'L. Collins',
    format: 'Paperback · 45 pages',
    cover: 'https://m.media-amazon.com/images/I/61kUsqembOL._SY522_.jpg',
    link: 'https://www.amazon.com/dp/B0DXLB6CCN',
    description: 'Master the Law of Attraction, reprogram your mind for success, and overcome fear and self-sabotage. Packed with practical exercises, affirmations, and real-world strategies. YOU are The Gem — now it\'s time to shine.'
  }
];

const BooksPage = () => {
  const bookCover = "https://customer-assets.emergentagent.com/job_f39e6fee-79f2-4684-89ed-32979a04e68f/artifacts/lwpwhqi3_71oE6dtI-wL._SY425_.jpg";
  const buyLink = "https://a.co/d/03sP8uyL";

  return (
    <div className="dark-page">
      <style>{`
        /* Mobile: shrink book covers so the library reads at a comfortable size on phones.
           Uses !important because the covers are inline-styled. */
        @media (max-width: 720px) {
          .books-hero-cover { max-width: 200px !important; }
          .books-grid-cover { width: 130px !important; height: 195px !important; margin-bottom: 16px !important; }
          .books-more-grid { grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)) !important; gap: 18px !important; }
        }
        @media (max-width: 480px) {
          .books-hero-cover { max-width: 170px !important; }
          .books-grid-cover { width: 110px !important; height: 165px !important; margin-bottom: 14px !important; }
          .books-more-grid { grid-template-columns: 1fr 1fr !important; gap: 14px !important; }
        }
      `}</style>
      {/* Hero Section */}
      <section className="tradelines-hero">
        <div className="tradelines-hero-content">
          <div className="tradelines-badge">THE COLLINS LIBRARY</div>
          <h1 className="display-huge tradelines-title" style={{ fontSize: '42px' }}>
            <span className="text-gradient">Books That Build Financial Power</span>
          </h1>
          <h2 style={{ color: 'white', fontSize: '24px', fontWeight: '500', margin: '15px 0 25px' }}>
            Five Titles. One Mission — Your Financial Freedom.
          </h2>
        </div>
      </section>

      {/* Book Display Section */}
      <section style={{ padding: '60px 7.6923%', background: 'var(--bg-secondary)' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '60px', maxWidth: '1200px', margin: '0 auto', alignItems: 'center', justifyContent: 'center' }}>
          
          {/* Book Cover */}
          <div style={{ flex: '0 0 auto' }}>
            <img 
              src={bookCover} 
              alt="Unlock Your Buying Power Book Cover" 
              className="books-hero-cover"
              style={{ 
                maxWidth: '350px', 
                width: '100%',
                borderRadius: '8px',
                boxShadow: '0 20px 60px rgba(0,0,0,0.5)'
              }}
            />
          </div>

          {/* Book Info */}
          <div style={{ flex: '1', minWidth: '300px', maxWidth: '550px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '20px' }}>
              {[1,2,3,4,5].map(i => (
                <Star key={i} size={24} fill="var(--accent-gold)" color="var(--accent-gold)" />
              ))}
            </div>
            
            <p style={{ color: 'var(--text-secondary)', fontSize: '17px', lineHeight: '1.8', marginBottom: '25px' }}>
              Designed to fill individuals with the knowledge and tools needed to take control of their financial future. Whether you're just starting out, looking to rebuild your credit, or aiming to fully understand the inner workings of the credit system, this book is your complete resource.
            </p>

            <p style={{ color: 'var(--text-secondary)', fontSize: '17px', lineHeight: '1.8', marginBottom: '30px' }}>
              With <strong style={{ color: 'white' }}>13 detailed chapters</strong>, this book covers everything from understanding your credit report to fixing errors, building strong credit, and navigating the complex web of credit bureaus and secondary bureaus.
            </p>

            <a 
              href={buyLink}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
              style={{ fontSize: '18px', padding: '18px 40px' }}
            >
              Buy Now on Amazon <ArrowRight size={20} />
            </a>
          </div>
        </div>
      </section>

      {/* More Books Collection */}
      <section style={{ padding: '80px 7.6923%' }} data-testid="more-books-section">
        <div className="section-header">
          <h2 className="display-medium section-title">More From The Collins Collection</h2>
          <p className="body-medium section-description">
            Knowledge that compounds — more titles from The Collins Academy, available on Amazon
          </p>
        </div>

        <div className="books-more-grid" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
          gap: '30px',
          maxWidth: '1300px',
          margin: '40px auto 0'
        }}>
          {moreBooks.map((book) => (
            <div
              key={book.id}
              data-testid={`book-card-${book.id}`}
              style={{
                background: 'rgba(35, 15, 61, 0.6)',
                border: '1px solid rgba(138, 93, 255, 0.3)',
                borderRadius: '14px',
                padding: '28px 24px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                transition: 'transform 0.3s ease-out, border-color 0.3s ease-out'
              }}
            >
              <img
                src={book.cover}
                alt={`${book.title} book cover`}
                loading="lazy"
                className="books-grid-cover"
                style={{
                  width: '180px',
                  height: '270px',
                  objectFit: 'cover',
                  borderRadius: '8px',
                  boxShadow: '0 14px 40px rgba(0,0,0,0.55)',
                  marginBottom: '22px'
                }}
              />
              <h3 style={{ color: 'white', fontSize: '19px', fontWeight: '700', marginBottom: '8px', lineHeight: '1.35' }}>
                {book.title}
              </h3>
              <p style={{ color: 'var(--accent-gold)', fontSize: '13px', fontWeight: '600', marginBottom: '4px' }}>
                {book.author}
              </p>
              <p style={{ color: 'var(--text-muted)', fontSize: '12px', marginBottom: '14px' }}>
                {book.format}
              </p>
              <p style={{ color: 'var(--text-secondary)', fontSize: '14px', lineHeight: '1.7', marginBottom: '22px', flex: '1' }}>
                {book.description}
              </p>
              <a
                href={book.link}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
                data-testid={`buy-book-${book.id}`}
              >
                Buy on Amazon <ArrowRight size={18} />
              </a>
            </div>
          ))}
        </div>
      </section>

      {/* What You'll Learn Section */}
      <section className="tradelines-grid-section">
        <div className="section-header">
          <h2 className="display-medium section-title">Inside, You'll Discover</h2>
        </div>
        
        <div className="wealth-for-grid" style={{ maxWidth: '1000px', margin: '0 auto' }}>
          <div className="wealth-for-item">
            <CheckCircle2 size={20} />
            <span>The fundamentals of credit scores, credit reports, and how they're used by lenders</span>
          </div>
          <div className="wealth-for-item">
            <CheckCircle2 size={20} />
            <span>Step-by-step strategies for repairing damaged credit and disputing errors</span>
          </div>
          <div className="wealth-for-item">
            <CheckCircle2 size={20} />
            <span>How to build strong credit from scratch, or after financial setbacks</span>
          </div>
          <div className="wealth-for-item">
            <CheckCircle2 size={20} />
            <span>Key insights into financial literacy for loans, credit cards, and debt management</span>
          </div>
          <div className="wealth-for-item">
            <CheckCircle2 size={20} />
            <span>A deep dive into secondary bureaus and how they impact your financial profile</span>
          </div>
          <div className="wealth-for-item">
            <CheckCircle2 size={20} />
            <span>Practical advice for protecting your credit from fraud and identity theft</span>
          </div>
        </div>
      </section>

      {/* Who Is This For Section */}
      <section className="wealth-for-section" style={{ background: 'var(--bg-secondary)' }}>
        <div className="section-header">
          <h2 className="display-medium section-title">Who Is This Book For?</h2>
        </div>
        
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '30px', justifyContent: 'center', maxWidth: '900px', margin: '30px auto 0' }}>
          <div style={{ 
            background: 'rgba(212, 175, 55, 0.1)', 
            border: '1px solid var(--border-purple)', 
            borderRadius: '12px', 
            padding: '25px 30px',
            flex: '1',
            minWidth: '250px',
            maxWidth: '280px',
            textAlign: 'center'
          }}>
            <BookOpen size={32} style={{ color: 'var(--accent-gold)', marginBottom: '15px' }} />
            <h3 style={{ color: 'white', fontSize: '18px', marginBottom: '10px' }}>First-Time Borrowers</h3>
            <p style={{ color: 'var(--text-secondary)', fontSize: '14px' }}>Learn the fundamentals before making your first credit decisions</p>
          </div>
          
          <div style={{ 
            background: 'rgba(212, 175, 55, 0.1)', 
            border: '1px solid var(--border-purple)', 
            borderRadius: '12px', 
            padding: '25px 30px',
            flex: '1',
            minWidth: '250px',
            maxWidth: '280px',
            textAlign: 'center'
          }}>
            <BookOpen size={32} style={{ color: 'var(--accent-gold)', marginBottom: '15px' }} />
            <h3 style={{ color: 'white', fontSize: '18px', marginBottom: '10px' }}>Credit Rebuilders</h3>
            <p style={{ color: 'var(--text-secondary)', fontSize: '14px' }}>Recover from financial challenges with proven strategies</p>
          </div>
          
          <div style={{ 
            background: 'rgba(212, 175, 55, 0.1)', 
            border: '1px solid var(--border-purple)', 
            borderRadius: '12px', 
            padding: '25px 30px',
            flex: '1',
            minWidth: '250px',
            maxWidth: '280px',
            textAlign: 'center'
          }}>
            <BookOpen size={32} style={{ color: 'var(--accent-gold)', marginBottom: '15px' }} />
            <h3 style={{ color: 'white', fontSize: '18px', marginBottom: '10px' }}>Seasoned Professionals</h3>
            <p style={{ color: 'var(--text-secondary)', fontSize: '14px' }}>Master the credit system for long-term financial success</p>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="tradelines-cta-section">
        <div className="tradelines-cta-content">
          <h2 className="display-medium">Your Road Map to Financial Freedom</h2>
          <p className="body-large" style={{ marginBottom: '30px', maxWidth: '700px', margin: '0 auto 30px' }}>
            This book is not just a guide—it's your road map to building a strong financial foundation and mastering the credit system for long-term success.
          </p>
          <a 
            href={buyLink}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
            style={{ fontSize: '18px', padding: '18px 40px' }}
          >
            Get Your Copy Now <ArrowRight size={20} />
          </a>
        </div>
      </section>
    </div>
  );
};

export default BooksPage;
